import { render } from "./avatar_url.vue?vue&type=template&id=bbb42122"
import script from "./avatar_url.vue?vue&type=script&lang=js"
export * from "./avatar_url.vue?vue&type=script&lang=js"

import "./avatar_url.vue?vue&type=style&index=0&id=bbb42122&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__